import { useRouter } from 'next/router';
import { useLazyGetCustomerPortalLinkQuery } from '../../services/users';
import { useCreateBillingPortalSessionMutation } from '../../services/entitlements/operations.generated';

export type UseRedirectToCustomerPortalReturnType = {
  redirectToCustomerPortal: () => Promise<void>;
};

export const useRedirectToCustomerPortal =
  (): UseRedirectToCustomerPortalReturnType => {
    const router = useRouter();
    const [getCustomerPortalLinkQuery] = useLazyGetCustomerPortalLinkQuery();

    const redirectToCustomerPortal = async (): Promise<void> => {
      const customerPortalLink = await getCustomerPortalLinkQuery().unwrap();

      void router.push({
        pathname: customerPortalLink,
      });
    };

    return {
      redirectToCustomerPortal,
    };
  };

export const useRedirectToCustomerPortalV2 =
  (): UseRedirectToCustomerPortalReturnType => {
    const router = useRouter();
    const [createBillingPortalSession] =
      useCreateBillingPortalSessionMutation();

    const redirectToCustomerPortal = async (options?: {
      returnUrl?: string;
      flowType?: 'updateSubscription' | 'cancelSubscription';
    }): Promise<void> => {
      const { createBillingPortalSession: data } =
        await createBillingPortalSession({
          input: {
            returnUrl: options?.returnUrl ?? window.location.href, // use current page as default return url,
            flowType: options?.flowType,
          },
        }).unwrap();

      void router.push({
        pathname: data.url,
      });
    };

    return {
      redirectToCustomerPortal,
    };
  };
